var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "opacity_FILL0_wght100_GRAD-25_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.4156 22C10.0746 22 8.08679 21.2039 6.45208 19.6118C4.81736 18.0197 4 16.0522 4 13.7093C4 12.5911 4.22523 11.5344 4.67569 10.5393C5.12615 9.5442 5.71561 8.64665 6.44409 7.84665L12.4185 2L18.3907 7.84412C19.1164 8.64453 19.7055 9.5426 20.1581 10.5383C20.6108 11.5341 20.8371 12.5911 20.8371 13.7093C20.8371 16.0522 20.0187 18.0197 18.382 19.6118C16.7454 21.2039 14.7566 22 12.4156 22ZM4.92652 14.8434C4.92652 14.8434 9.22352 17.4153 12.4329 14.8434C15.6423 12.2716 19.9393 14.8434 19.9393 14.8434C20.197 13.3099 20.0468 11.9937 19.4886 10.8947C18.9305 9.79581 18.3669 8.97824 17.7978 8.44201L12.4185 3.10224L7.03741 8.4422C6.46817 8.97845 5.91546 9.79606 5.3793 10.895C4.84315 11.994 4.69223 13.3101 4.92652 14.8434Z",
    fill: "#183883"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/Water.a80cd087cbc14aa7f7f298359a997254.svg";
export { ForwardRef as ReactComponent };